import React, { ComponentType } from 'react';
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom';

import useAuth from 'features/auth/hooks/useAuth';
import type { UserRole } from 'features/user/ts/UserRole';
import { authPaths } from 'features/auth/routes/paths';
import useUser from 'features/user/hooks/useUser';
import { hasRequiredRoles } from 'features/user/utils/hasRequiredRoles';
import { rootPaths } from 'routes/paths';
import { Loader } from 'shared/loaders';

interface PrivateRouteProps extends RouteProps {
  roles?: UserRole[];
  component: ComponentType<RouteComponentProps>;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  render,
  roles: requiredRoles = [],
  ...rest
}) => {
  const { isLoggedIn } = useAuth();
  const { user, isLoading } = useUser();

  const renderComponent = (props: RouteComponentProps) => {
    if (isLoading) return <Loader />;

    if (!isLoggedIn) {
      return <Redirect to={authPaths.static.login} />;
    } else if (user) {
      if (hasRequiredRoles(user.roles, requiredRoles)) {
        return <Component {...props} />;
      }

      return <Redirect to={rootPaths.static.forbidden} />;
    } else {
      return Component ? <Component {...props} /> : null;
    }
  };
  return <Route {...rest} render={render || renderComponent} />;
};
